import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'fromUnderscoreToText',
  pure: true
})
export class FromUnderscoreToTextPipe implements PipeTransform {

  transform(value?: string): string {
    if (!value) {
      return ''
    }
    // Split the value by underscores
    const parts = value.split('_');

    // Capitalize each word and join them with a space
    const transformedText = parts.map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');

    return transformedText;
  }

}
